import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';

@Component({
    selector: 'app-button-link',
    templateUrl: './button-link.component.html',
    styleUrl: './button-link.component.scss',
    imports: [
        CommonModule
    ],
    host: {
        'role': 'button'
    }
})
export class ButtonLinkComponent {

    $text = input.required<string>({ alias: 'text' });
    $icon = input<string>('arrow-right-long', { alias: 'icon' });

    ngClassIcon = computed<string>(() => {
        let icon = this.$icon() ?? 'arrow-right-long';
        return icon?.startsWith('fa-') ? icon : 'fa-' + icon;
    })

}
